import { render, staticRenderFns } from "./VerifyPayment.vue?vue&type=template&id=06addfda&scoped=true&"
import script from "./VerifyPayment.vue?vue&type=script&lang=js&"
export * from "./VerifyPayment.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPayment.vue?vue&type=style&index=0&id=06addfda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06addfda",
  null
  
)

export default component.exports